function _typeof(o) {
  "@babel/helpers - typeof";

  return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) {
    return typeof o;
  } : function (o) {
    return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o;
  }, _typeof(o);
}
function _regenerator() {
  /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */var e,
    t,
    r = "function" == typeof Symbol ? Symbol : {},
    n = r.iterator || "@@iterator",
    o = r.toStringTag || "@@toStringTag";
  function i(r, n, o, i) {
    var c = n && n.prototype instanceof Generator ? n : Generator,
      u = Object.create(c.prototype);
    return _regeneratorDefine2(u, "_invoke", function (r, n, o) {
      var i,
        c,
        u,
        f = 0,
        p = o || [],
        y = !1,
        G = {
          p: 0,
          n: 0,
          v: e,
          a: d,
          f: d.bind(e, 4),
          d: function d(t, r) {
            return i = t, c = 0, u = e, G.n = r, a;
          }
        };
      function d(r, n) {
        for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) {
          var o,
            i = p[t],
            d = G.p,
            l = i[2];
          r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0));
        }
        if (o || r > 1) return a;
        throw y = !0, n;
      }
      return function (o, p, l) {
        if (f > 1) throw TypeError("Generator is already running");
        for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) {
          i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u);
          try {
            if (f = 2, i) {
              if (c || (o = "next"), t = i[o]) {
                if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object");
                if (!t.done) return t;
                u = t.value, c < 2 && (c = 0);
              } else 1 === c && (t = i["return"]) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1);
              i = e;
            } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break;
          } catch (t) {
            i = e, c = 1, u = t;
          } finally {
            f = 1;
          }
        }
        return {
          value: t,
          done: y
        };
      };
    }(r, o, i), !0), u;
  }
  var a = {};
  function Generator() {}
  function GeneratorFunction() {}
  function GeneratorFunctionPrototype() {}
  t = Object.getPrototypeOf;
  var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () {
      return this;
    }), t),
    u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c);
  function f(e) {
    return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e;
  }
  return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () {
    return this;
  }), _regeneratorDefine2(u, "toString", function () {
    return "[object Generator]";
  }), (_regenerator = function _regenerator() {
    return {
      w: i,
      m: f
    };
  })();
}
function _regeneratorDefine2(e, r, n, t) {
  var i = Object.defineProperty;
  try {
    i({}, "", {});
  } catch (e) {
    i = 0;
  }
  _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) {
    function o(r, n) {
      _regeneratorDefine2(e, r, function (e) {
        return this._invoke(r, n, e);
      });
    }
    r ? i ? i(e, r, {
      value: n,
      enumerable: !t,
      configurable: !t,
      writable: !t
    }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2));
  }, _regeneratorDefine2(e, r, n, t);
}
function _createForOfIteratorHelper(r, e) {
  var t = "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"];
  if (!t) {
    if (Array.isArray(r) || (t = _unsupportedIterableToArray(r)) || e && r && "number" == typeof r.length) {
      t && (r = t);
      var _n = 0,
        F = function F() {};
      return {
        s: F,
        n: function n() {
          return _n >= r.length ? {
            done: !0
          } : {
            done: !1,
            value: r[_n++]
          };
        },
        e: function e(r) {
          throw r;
        },
        f: F
      };
    }
    throw new TypeError("Invalid attempt to iterate non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method.");
  }
  var o,
    a = !0,
    u = !1;
  return {
    s: function s() {
      t = t.call(r);
    },
    n: function n() {
      var r = t.next();
      return a = r.done, r;
    },
    e: function e(r) {
      u = !0, o = r;
    },
    f: function f() {
      try {
        a || null == t["return"] || t["return"]();
      } finally {
        if (u) throw o;
      }
    }
  };
}
function _unsupportedIterableToArray(r, a) {
  if (r) {
    if ("string" == typeof r) return _arrayLikeToArray(r, a);
    var t = {}.toString.call(r).slice(8, -1);
    return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0;
  }
}
function _arrayLikeToArray(r, a) {
  (null == a || a > r.length) && (a = r.length);
  for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e];
  return n;
}
function ownKeys(e, r) {
  var t = Object.keys(e);
  if (Object.getOwnPropertySymbols) {
    var o = Object.getOwnPropertySymbols(e);
    r && (o = o.filter(function (r) {
      return Object.getOwnPropertyDescriptor(e, r).enumerable;
    })), t.push.apply(t, o);
  }
  return t;
}
function _objectSpread(e) {
  for (var r = 1; r < arguments.length; r++) {
    var t = null != arguments[r] ? arguments[r] : {};
    r % 2 ? ownKeys(Object(t), !0).forEach(function (r) {
      _defineProperty(e, r, t[r]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) {
      Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r));
    });
  }
  return e;
}
function _defineProperty(e, r, t) {
  return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, {
    value: t,
    enumerable: !0,
    configurable: !0,
    writable: !0
  }) : e[r] = t, e;
}
function _toPropertyKey(t) {
  var i = _toPrimitive(t, "string");
  return "symbol" == _typeof(i) ? i : i + "";
}
function _toPrimitive(t, r) {
  if ("object" != _typeof(t) || !t) return t;
  var e = t[Symbol.toPrimitive];
  if (void 0 !== e) {
    var i = e.call(t, r || "default");
    if ("object" != _typeof(i)) return i;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r ? String : Number)(t);
}
function asyncGeneratorStep(n, t, e, r, o, a, c) {
  try {
    var i = n[a](c),
      u = i.value;
  } catch (n) {
    return void e(n);
  }
  i.done ? t(u) : Promise.resolve(u).then(r, o);
}
function _asyncToGenerator(n) {
  return function () {
    var t = this,
      e = arguments;
    return new Promise(function (r, o) {
      var a = n.apply(t, e);
      function _next(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "next", n);
      }
      function _throw(n) {
        asyncGeneratorStep(a, r, o, _next, _throw, "throw", n);
      }
      _next(void 0);
    });
  };
}
var MOCK_THREAD_TEXTS = ['This reply simulates a deeper thread from the archive.', 'More conversation below the critical path — loaded on demand.', 'Thread scrolling appends replies without rebuilding the view.', 'Another mock reply while archive queries are still stubbed out.'];
var MOCK_AUTHOR_KEYS = ['redsquare-mock-pk-saito', 'redsquare-mock-pk-rp', 'redsquare-mock-pk-alice', 'redsquare-mock-pk-bob', 'redsquare-mock-pk-carol', 'redsquare-mock-pk-dave'];
var MAX_MOCK_PAGES = 2;
function makeLoadResult(type, direction) {
  var _ref = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {},
    _ref$added = _ref.added,
    added = _ref$added === void 0 ? [] : _ref$added,
    _ref$updated = _ref.updated,
    updated = _ref$updated === void 0 ? [] : _ref$updated,
    _ref$ignored = _ref.ignored,
    ignored = _ref$ignored === void 0 ? [] : _ref$ignored,
    _ref$exhausted = _ref.exhausted,
    exhausted = _ref$exhausted === void 0 ? false : _ref$exhausted;
  return {
    type: type,
    direction: direction,
    added: added.slice(),
    updated: updated.slice(),
    ignored: ignored.slice(),
    exhausted: Boolean(exhausted)
  };
}
function sliceUnrendered(signatures, cursor, batchSize) {
  if (cursor >= signatures.length) {
    return [];
  }
  return signatures.slice(cursor, cursor + batchSize);
}
function buildMockTweetTx(_ref2) {
  var signature = _ref2.signature,
    publicKey = _ref2.publicKey,
    text = _ref2.text,
    _ref2$parent_id = _ref2.parent_id,
    parent_id = _ref2$parent_id === void 0 ? '' : _ref2$parent_id,
    _ref2$thread_id = _ref2.thread_id,
    thread_id = _ref2$thread_id === void 0 ? '' : _ref2$thread_id;
  return {
    signature: signature,
    timestamp: Date.now() - Math.floor(Math.random() * 7 * 24 * 60 * 60 * 1000),
    from: [{
      publicKey: publicKey,
      amount: '0',
      type: 1,
      index: 0,
      blockId: '0',
      txOrdinal: '0'
    }],
    msg: {
      module: 'RedSquare',
      request: 'create tweet',
      data: {
        text: text,
        images: [],
        parent_id: parent_id,
        thread_id: thread_id || signature
      }
    },
    optional: {
      num_likes: Math.floor(Math.random() * 120),
      num_replies: Math.floor(Math.random() * 24),
      num_retweets: Math.floor(Math.random() * 40)
    }
  };
}
function pickAuthor() {
  var index = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 0;
  return MOCK_AUTHOR_KEYS[index % MOCK_AUTHOR_KEYS.length];
}
function ingestThreadBatch(mod, threadId, parentSignature, page, batchSize) {
  var added = [];
  var updated = [];
  var ignored = [];
  for (var i = 0; i < batchSize; i++) {
    var textIndex = page * batchSize + i;
    if (textIndex >= MOCK_THREAD_TEXTS.length) {
      break;
    }
    var signature = "redsquare-mock-tx-thread-".concat(threadId.slice(-3), "-").concat(page + 1, "-").concat(i + 1);
    if (mod.hasTweet(signature)) {
      ignored.push(signature);
      continue;
    }
    var tx = buildMockTweetTx({
      signature: signature,
      publicKey: pickAuthor(textIndex + 2),
      text: MOCK_THREAD_TEXTS[textIndex],
      parent_id: parentSignature,
      thread_id: threadId
    });
    var tweet = mod.addTweet(tx);
    if (tweet) {
      added.push(signature);
    } else {
      ignored.push(signature);
    }
  }
  return {
    added: added,
    updated: updated,
    ignored: ignored
  };
}
function loadThreadPage(_x, _x2, _x3, _x4) {
  return _loadThreadPage.apply(this, arguments);
}
function _loadThreadPage() {
  _loadThreadPage = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee(mod, pagination, active_thread_id, active_signature) {
    var pending, parentSignature, buckets, _iterator, _step, signature;
    return _regenerator().w(function (_context) {
      while (1) switch (_context.n) {
        case 0:
          pending = sliceUnrendered(pagination.chain, pagination.cursor, pagination.batchSize);
          if (!(pending.length > 0)) {
            _context.n = 1;
            break;
          }
          return _context.a(2, makeLoadResult('thread', 'older', {
            added: pending,
            exhausted: false
          }));
        case 1:
          if (!(pagination.mockPage >= MAX_MOCK_PAGES)) {
            _context.n = 2;
            break;
          }
          return _context.a(2, makeLoadResult('thread', 'older', {
            exhausted: true
          }));
        case 2:
          parentSignature = active_signature || pagination.chain[0] || '';
          if (!(!parentSignature || !active_thread_id)) {
            _context.n = 3;
            break;
          }
          return _context.a(2, makeLoadResult('thread', 'older', {
            exhausted: true
          }));
        case 3:
          buckets = ingestThreadBatch(mod, active_thread_id, parentSignature, pagination.mockPage, pagination.batchSize);
          pagination.mockPage += 1;
          if (!(buckets.added.length === 0)) {
            _context.n = 4;
            break;
          }
          return _context.a(2, makeLoadResult('thread', 'older', _objectSpread(_objectSpread({}, buckets), {}, {
            exhausted: true
          })));
        case 4:
          _iterator = _createForOfIteratorHelper(buckets.added);
          try {
            for (_iterator.s(); !(_step = _iterator.n()).done;) {
              signature = _step.value;
              pagination.chain.push(signature);
            }
          } catch (err) {
            _iterator.e(err);
          } finally {
            _iterator.f();
          }
          return _context.a(2, makeLoadResult('thread', 'older', _objectSpread(_objectSpread({}, buckets), {}, {
            exhausted: false
          })));
      }
    }, _callee);
  }));
  return _loadThreadPage.apply(this, arguments);
}
function loadMore(_x5) {
  return _loadMore.apply(this, arguments);
}
function _loadMore() {
  _loadMore = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2(_ref3) {
    var mode, mod, pagination, active_thread_id, active_signature;
    return _regenerator().w(function (_context2) {
      while (1) switch (_context2.n) {
        case 0:
          mode = _ref3.mode, mod = _ref3.mod, pagination = _ref3.pagination, active_thread_id = _ref3.active_thread_id, active_signature = _ref3.active_signature;
          if (!(mode !== 'thread')) {
            _context2.n = 1;
            break;
          }
          return _context2.a(2, makeLoadResult(mode || 'tweets', 'older', {
            exhausted: true
          }));
        case 1:
          return _context2.a(2, loadThreadPage(mod, pagination.thread, active_thread_id, active_signature));
      }
    }, _callee2);
  }));
  return _loadMore.apply(this, arguments);
}
module.exports = {
  loadMore: loadMore
};